module.exports = __webpack_public_path__ + "img/Den_Norske_Dictionarium_Den_første_norske_ordboka.a5be2133.jpg";